module.exports = __webpack_public_path__ + "img/001-098@2x.7e1911f3.png";